"use strict";

export default class FormConfirmRestore {
    constructor() {
        let self = this;

        $("form.confirm-restore").off().on("submit", function() {
            let _this = this;
            self.showRestoreConfirmationModal(this, function() {
                _this.submit();
            });
            return false;
        });
    }

    showRestoreConfirmationModal(elem, callback) {
        let content = $(elem).attr("data-content");
        let dialog = new Dialog();
        dialog.confirm("Confirm Restore", content ? content : "Are you sure you want to restore this item?", callback);
    }
}
